var css = {"footerTopGrid":"Footer-module_footerTopGrid__Nikgc","footerBottomGrid":"Footer-module_footerBottomGrid__3Ugx_","imageLinkWithHoverContainer":"Footer-module_imageLinkWithHoverContainer__3Ysgh","linkOnHoverState":"Footer-module_linkOnHoverState__2arn0","linkOnDefaultState":"Footer-module_linkOnDefaultState__nJLjb"};

export { css as default };
